import React from "react";

const GlobalFormCard = ({
    title,
    subtitle,
    icon,
    children,
    maxWidth = "900px", // control width globally
    fullWidth = false,
}) => {
    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    background: "#fff",
                    border: "0.5px solid #e5e5e5",
                    borderRadius: fullWidth ? 0 : 16,
                    padding: "1.75rem",
                    width: "100%",
                    maxWidth: fullWidth ? "100%" : maxWidth,
                }}
            >
                {/* Header */}
                {(title || subtitle) && (
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: "1.5rem" }}>
                        {icon && (
                            <div
                                style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: 10,
                                    background: "#E6F1FB",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                {icon}
                            </div>
                        )}
                        <div>
                            <p style={{ fontSize: 15, fontWeight: 500, margin: 0 }}>{title}</p>
                            <p style={{ fontSize: 12, color: "#aaa", margin: 0 }}>{subtitle}</p>
                        </div>
                    </div>
                )}

                {/* Dynamic Content */}
                {children}
            </div>
        </div>
    );
};

export default GlobalFormCard;